// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Пропозиції громадян» (Citizens Proposals, ключ `cpr`, група `legislation`). */
export const citizensProposalsManifest: IModuleManifest = {
  key: 'cpr',
  group: 'legislation',
  slug: 'citizens-proposals',
  prefix: 'CPR',
  name: { en: 'Citizens Proposals', uk: 'Пропозиції громадян' },
  entities: [
    { key: 'cpr', slug: 'cpr', name: { en: 'Citizens Proposals', uk: 'Пропозиції громадян' }, main: true },
    { key: 'proposal_supporter', slug: 'proposal-supporter', name: { en: 'Proposal Supporters', uk: 'Прихильники' }, main: false },
    { key: 'proposal_review', slug: 'proposal-review', name: { en: 'Proposal Reviews', uk: 'Перевірки' }, main: false },
    { key: 'proposal_outcome', slug: 'proposal-outcome', name: { en: 'Proposal Outcomes', uk: 'Результати' }, main: false },
  ],
  loadState: () => import('./state/citizensProposalsSlice').then((m) => m.citizensProposalsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
